
const NameRegex = new RegExp(/(^[#\w_-]+\.)?([\w_-]+)(:\w+$)?/g, "g")
const KeyEvents = ['keydown', 'keyup', 'keypress']
const KeyCodesModifiers = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'ctrl': 17,
  'esc': 27,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
}

export class EventsHandler {

  constructor(context = this) {
    this.entries = []
    this.customEntries = []
    this.context = context
  }

  getTargetObject(targetName) {
    const defaultContext = this.context
    if (typeof targetName === 'string' && targetName.startsWith('#')) {
      return this.context.querySelector(targetName)
    }
    return {
      document: global.window.document,
      window: global.window,
    }[targetName] || defaultContext
  }

  setDefaultContext(context) {
    this.context = context
  }

  parseEventName(eventName) {
    NameRegex.lastIndex = 0
    const match = NameRegex.exec(eventName)
    const clean = (v) => typeof v == 'string' ? v.replace(/:|\./g, '') : v
    const [, target, name, modifier] = Array.from(match).map(clean)
    return {
      keyEvent: KeyEvents.includes(name),
      target: this.getTargetObject(target),
      name,
      modifier
    }
  }

  createKeyEventCallback(modifier, callback) {
    const keyCode = KeyCodesModifiers[modifier]
    return (e) => {
      if (e.keyCode === keyCode) {
        callback(e)
      }
    }
  }

  parseEntry(entry) {
    let [key, callback] = entry
    const eventParams = this.parseEventName(key)
    if (eventParams.keyEvent && eventParams.modifier) {
      callback = this.createKeyEventCallback(eventParams.modifier, callback)
    }
    return {
      ...eventParams,
      callback,
      addListener() {
        this.target.addEventListener(this.name, callback)
      },
      removeListener() {
        this.target.removeEventListener(this.name, callback)
      }
    }
  }

  addListener(target, eventName, callback) {
    this.customEntries.push({
      addListener() { target.addEventListener(eventName, callback) },
      removeListener() { target.removeEventListener(eventName, callback) },
    })
  }

  isInvalidEntry(entry) {
    if (entry.target === undefined) return false
    if (entry.callback === undefined) return false
    return true
  }

  initEvents(eventsDescriptor) {
    this.unbindAll()
    this.entries = Object.entries(eventsDescriptor)
      .map((entry) => this.parseEntry(entry))
      .filter(this.isInvalidEntry)
  }

  bindAll() {
    this.unbindAll()
    const entries = [...this.entries, ...this.customEntries]
    entries.forEach(e => e.addListener())
  }

  unbindAll() {
    const entries = [...this.entries, ...this.customEntries]
    entries.forEach(e => e.removeListener())
  }
}